import {
    GET_DENTIST_DETAILS_REQUEST, GET_DENTIST_DETAILS_SUCCESS, GET_DENTIST_DETAILS_FAILURE
} from './constants';

const initialState = {
    loading: true,
    adminDentistDetails: undefined,
};


const adminDentistDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_DENTIST_DETAILS_REQUEST: {
            return Object.assign({}, state, {loading: false, adminDentistDetails: undefined});
        }
        case GET_DENTIST_DETAILS_SUCCESS: {
            return Object.assign({}, state, {loading: false, adminDentistDetails: action.data.dentistDetails});
        }
        case GET_DENTIST_DETAILS_FAILURE: {
            return Object.assign({}, state, {loading: false, error: action.data.errors});
        }
        default: {
            return state;
        }
    }
};

export default adminDentistDetailsReducer;



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/DentistDetails/reducer.js